import { createContext, useContext, useState, useRef } from "react";
import TopLoader from "../components/TopLoader.jsx";

const TopLoaderContext = createContext();

export const TopLoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);

  const start = () => {
    if (loading) return;

    setLoading(true);
    setProgress(10);

    intervalRef.current = setInterval(() => {
      setProgress((prev) => (prev < 90 ? prev + Math.random() * 10 : prev));
    }, 300);
  };

  const stop = () => {
    clearInterval(intervalRef.current);
    setProgress(100);

    setTimeout(() => {
      setLoading(false);
      setProgress(0);
    }, 300);
  };

  return (
    <TopLoaderContext.Provider value={{ start, stop }}>
      {children}
      {loading && <TopLoader progress={progress} />}
    </TopLoaderContext.Provider>
  );
};

export const useTopLoader = () => useContext(TopLoaderContext);
